module.exports = {
  change: 'Change',
  documents: {
    icon: {
      errorText: 'You have to select one from the list!',
    },
    files: {
      removeConfirmTitle: 'Remove the document',
      removeConfirmText: 'Are you sure that you want to remove',
      saveConfirmTitle: 'Clear the reading history',
      saveConfirmText: 'If you save now the entire reading history for this file will be cleared',
      clearReadingHistory: 'Clear the reading history',
      read: 'Read',
      times: 'times',
      readingHistory: 'Reading history',
      readingHistoryInformation: 'When this is checked the reading history will be cleared if a new file is uploaded.',
      noVenue: 'Belongs to no venue',
      new: 'New Document',
      defaultName: 'untitled document',
      uploadText: 'Upload a file the belongs to this document',
      link: 'Link',
      fields: {
        name: 'Name',
        description: 'Description',
        fileSrc: 'File',
        externalLink: 'Use external link instead of uploading file',
      },
    },
    directory: {
      removeCurrent: 'Remove this folder',
      updateCurrent: 'Update this folder',
      dialogTitle: 'Folder: ',
      name: 'Folder',
      new: 'New Folder',
      userPermitted: 'Permitted users',
      chooseAll: 'Select all',
      fields: {
        name: 'Name',
        description: 'Description',
        icon: 'Folder icon',
      },
      defaultName: 'untitled folder',
    },
  },
  'confirm.title': 'Are you sure?',
  resources: {
    documents: {
      name: 'Files',
    },
    quizes: {
      name: 'Quiz |||| Quizzes',
      fields: {
        prio: 'Priority',
        internalTitle: 'Title (internal use)',
        buttonText: 'Text for the start button',
        description: 'Description',
        active: 'Active',
        market: 'Market',
        'promoImage.alt': 'Description of promotion image',
        'promoImage.image': 'Promotion image',
        checkpoint: 'Checkpoint',
        'checkpoints.amount': 'Number of questions to ask.',
        'checkpoints.title': 'Title',
        'checkpoints.text': 'Description',
        'checkpoints.buttonText': 'Text for the start button',
        'checkpoints.video': 'Video',
        'checkpoints.minCorrectAnswers': 'Minimum number of correct answers',
        'checkpoints.randomOrder': 'Order questions randomly',
        'checkpoints.question': 'Questions',
        questions: 'Questions',
        'questions.title': 'Question',
        'questions.time': 'Maximum number of seconds',
        'questions.level': 'Level',
        'questions.correct': 'Correct answer',
        'questions.options': 'Options',
        'questions.type': 'Question type',
        'questions.isCorrect': 'Which one is the correct answer?',
        'questions.pair1': 'First Pair',
        'questions.pair2': 'Second Pair',
        'questions.pair3': 'Third Pair',
        'questions.category1Name': 'Name of the first category',
        'questions.category1': 'Content of the first category',
        'questions.category2Name': 'Name of the second category',
        'questions.category2': 'Content of the second category',
      },
      'checkpoints.removeConfirm': 'Are you sure that you want to remove this checkpoint?',
      'questions.removeConfirm': 'Are you sure that you want to remove this question?',
      'questions.singleSelect': 'Multiple choice (one correct answer)',
      'questions.multipleSelect': 'Multiple choice (mutliple correct answers)',
      'questions.binary': 'Yes or No question',
      'questions.pair': 'Pairing exercise',
      'questions.sort': 'Sorting exercise (swipe)',
      'questions.imageSelect': 'Image select',
      'questions.imageSelect.selectedTitle': 'Choosen',
      'questions.imageSelect.selectedSubtitle': 'This image will be the correct answer to this question.',
      'questions.imageSelect.correctHint': 'Choose an image below as the correct answer to this question.',
      'questions.imageSelect.optionsHint': 'Upload images which will be options in this question.',
      promoUpload: 'Each Quiz requires a promotion image! Drag and drop an image to upload it, or click to choose a file.',
      yes: 'Yes',
      no: 'No',
    },
    products: {
      name: 'Product |||| Products',
      fields: {
        submittedBy: 'Submitted by',
        title: 'Title',
        subtitle: 'Subtitle',
        stations: 'Stations',
        account: 'Account',
        code: 'Code',
        private: 'Cashier product',
        unlockedBy: 'Unlocked by',
        markets: 'Markets',
        mainImageUrl: 'Product image',
        gifImageUrl: 'Animated gif image',
        category: 'Category',
        types: 'Types',
        diets: 'Diets',
        allergens: 'Allergens (old)',
        provisionalImageUrl: 'Suggested image',
        alcoholic: 'Alcoholic',
        readyToDrink: 'Ready to drink',
        productContents: 'Product contents',
        standardTaxCode: 'Standard VAT Code (Norwegian products)',
        costPerPortion: 'Commodity price per portion',
        recipes: 'Recipes',
        ingredientList: 'Ingredients',
        name: 'Name',
        market: 'Price market',
        updated: 'Updated',
        listOfContent: 'List of Contents (old freetext)',
        ingredients: 'Ingredients (old free-text)',
        ingredientsWithHint: 'Ingredients with article number',
        instructions: 'Instructions',
        servingWeight: 'Serving Weight',
        servingPlatter: 'Served with / in / on:',
        mainCategory: 'Main category',
        internalName: 'Internal name',
        suggestedPrice: 'Suggested price',
        minPrice: 'Min. price',
        maxPrice: 'Max. price',
        contents: 'Declaration of contents',
        'contents.supplier': 'Supplier',
        'contents.supplierOrderId': 'Sup. order ID',
        'contents.description': 'Description',
        'contents.amount': 'Amount',
        'contents.unit': 'Unit',
        takeAwayEnabled: 'Take Away enabled',
        autoActivation: 'Automatic activation (activates daily, if paused in assortment)',
        takeAwayOnly: 'Take Away only, this product cannot be used in regular menu',
        venueWhitelist: 'Allowed restaurants',
        provisionalData: {
          state: 'Status',
          venues: 'Venues',
          discussion: 'Internal comments',
        },
        downloadButton: 'Download image',
        downloadInfo: 'If image is opened in new window, right click - choose Save as.',
        variablePrice: 'Product accepts a flexible, used for physical giftcards',
      },
      productSheet: 'Product Sheet',
      frozen: 'Do you want to remove the product from all assortments? THIS CANNOT BE UNDONE',
    },
    'product-order': {
      name: 'Product Order |||| Product Order',
    },
    'frozen-products': {
      name: 'Frozen product |||| Frozen products',
      fields: {
        category: 'Category',
        internalName: 'Internal name',
      },
    },
    faq: {
      name: 'Q & A |||| Q & A',
      fields: {
        identifier: 'Internal name',
        question: 'Question',
        answer: 'Answer',
      },
    },
    'web-sites': {
      name: 'Website |||| Websites',
      fields: {
        name: 'Name',
        market: 'Market',
      },
    },
    'web-pages': {
      name: 'Web page |||| Web pages',
      fields: {
        slug: 'URL slug',
        bannerTitle: 'Banner title',
        metaContent: {
          title: 'Meta <title>',
          ogTitle: 'Meta <og:title>',
          description: 'Meta <description>',
        },
        headingBold: 'Bold Heading',
        headingThin: 'Thin Heading',
        video: 'Video link',
        videoPoster: 'Video poster',
        backupImage: 'Backup image',
        heroImage: 'Hero image',
        custom: 'Custom',
        blocks: 'Blocks',
        promos: 'Promos',
        website: 'Website',
        'website.name': 'Website',
      },
    },
    'web-promos': {
      name: 'Promo |||| Promos',
      fields: {
        internalName: 'Internal name',
        tag: 'Tag',
        headingBold: 'Heading - bold',
        headingThin: 'Heading - thin',
        image: 'Image',
        button: {
          show: 'Show',
          text: 'Text',
          internal: 'Internal',
          link: 'Link',
        },
      },
    },
    recipes: {
      name: 'Recipe |||| Recipes',
      fields: {
        name: 'Name',
      },
    },
    'provisional-products': {
      name: 'Suggested Product |||| Suggested Products',
      fields: {
        submittedBy: 'Submitted by',
        title: 'Title',
        subtitle: 'Subtitle',
        stations: 'Stations',
        mainImageUrl: 'Product image',
        market: 'Price market',
        category: 'Category',
        allergens: 'Allergener',
        instructions: 'Instructions',
        mainCategory: 'Main category',
        markets: {
          suggestedPrice: 'Suggested price',
        },
        provisionalData: {
          state: 'Status',
          venues: 'Venues',
          discussion: 'Internal comments',
        },
        provisionalImageUrl: 'Suggested image',
        alcoholic: 'Alcoholic',
        readyToDrink: 'Ready to drink',
      },
    },
    'locked-products': {
      name: 'Standard product |||| Standard products',
    },
    'price-segments': {
      name: 'Price segments',
    },
    'promoted-products': {
      name: 'Promoted product |||| Promoted products',
      fields: {
        category: 'Category',
        markets: 'Markets',
        product: 'Product',
      },
    },
    allergens: {
      name: 'Allergen |||| Allergens',
      fields: {
        title: 'Title',
        mainAllergen: 'Main Allergen',
      },
    },
    diets: {
      name: 'Diet |||| Diets',
      fields: {
        title: 'Title',
      },
    },
    suppliers: {
      name: 'Supplier |||| Suppliers',
    },
    ingredients: {
      name: 'Ingredient |||| Ingredients',
      fields: {
        GTIN: 'GTIN',
        supplier: 'Supplier',
        description: 'Name',
        supplierOrderId: "Supplier's order ID",
        edible: 'Edible',
        originCountryCode: 'Origin country',
        displayName: 'Name in app (origin country)',
      },
    },
    categories: {
      name: 'Category |||| Categories',
      fields: {
        title: 'Title',
        subtitle: 'Subtitle',
        mainImageUrl: 'Category image',
        mainCategory: 'Main category',
        description: 'Description',
        headerUrl: 'Link to webpage',
        scrollDirection: 'Which direction the meny scrolls',
      },
      horizontal: 'Sideways',
      vertical: 'Normally',
    },
    venues: {
      name: 'Restaurant |||| Restaurants',
      fields: {
        published: 'Published',
        name: 'Name',
        code: 'Code',
        title: 'Title',
        subtitle: 'Subtitle',
        email: 'Email',
        mobileNumber: 'Mobile number',
        visitationAddress: 'Visitation address',
        'visitationAddress.addressLine1': 'Address',
        'visitationAddress.city': 'City',
        'visitationAddress.zipCode': 'Zip code',
        'visitationAddress.country': 'Country',
        takeAwayVisitationAddress: 'Take Away Visitation address',
        'takeAwayVisitationAddress.addressLine1': 'Take Away Address',
        'takeAwayVisitationAddress.city': 'Take Away City',
        'takeAwayVisitationAddress.zipCode': 'Take Away Zip code',
        'takeAwayVisitationAddress.country': 'Take Away Country',
        loc: 'Location',
        'loc.coordinates': 'Location',
        'loc.coordinates[0]': 'Longitude',
        'loc.coordinates[1]': 'Latitude',
        'urls.jobApplication': 'Job Application URL',
        'urls.facebook': 'Facebook link (webpage, editorial)',
        'urls.instagram': 'Instagram link (webpage, editorial)',
        'urls.woltUrl': 'Wolt link (editorial)',
        'urls.foodora': 'Foodora link (editorial)',
        'urls.npsOverride': 'Post-payment survey (NPS) override',
        'urls.selectionOverride': 'Override where list-item for this venues goes',
        'openHours.locked': 'Open hours locked (super users can edit)',
        extOrderData: 'External Order data',
        'extData.externalId': 'Sync choices',
        'extOrderData.externalId': 'WSAB ID',
        appIdWhitelist: 'Published',
        countryCode: 'Country code',
        languageCode: 'Language code',
        organisationNumber: 'Organisation number',
        customerId: 'Customer ID',
        franchiseGroup: 'Franchise group',
        tipLimitFactor: 'Tip limit percentage',
        tipLimit: 'Tip limit',
        quickPayFactor: 'Quick pay percentage (0 hides the button in the app)',
        billingAllowed: 'Billing allowed',
        deliveryEnabled: 'Delivery enabled',
        pickupEnabled: 'Pickup enabled',
        supportedPSPs: 'Supported payment methods',
        takeAwayEnabled: 'Take Away active',
        creperieEnabled: 'Crepes & Galettes active',
        creperieTakeAwayEnabled: 'Crepes & Galettes Take Away active',
        autoActivation: 'Automatic product activation',
        orderStates: 'Order status',
        paynovaLocationId: 'Paynova location ID',
        paynovaMaxAmount: 'Paynova max amount',
        paynovaInvoiceMID: 'Paynova Invoice Merchant ID',
        paynovaInvoiceMPW: 'Paynova Invoice Merchant Password',
        adyenMID: 'Adyen Merchant ID',
        adyenTerminalMID: 'Adyen Terminal Merchant ID (TapToPay)',
        swishMID: 'Swish Merchant ID',
        vippsMID: 'Vipps Merchant ID',
        tableBooking: 'Tablebooking',
        'tableBooking.href': 'Tablebooking-link',
        'tableBooking.overrideHref': 'Override tablebooking-link',
        'tableBooking.googleBookingEnabled': 'Google Booking',
        isOpen: 'Is open',
        'reordering.message': 'Reordering reminder',
        'reordering.timeout': 'Schedule reminder (seconds)',
        products: 'Products',
        market: 'Market',
        placeId: 'Places',
        'it.operations': 'IT operations',
        'it.primaryNetwork': 'Primary fiber provider',
        'it.backupNetwork': 'Backup network provider',
        'it.printerServer': 'Printer server',
        classifications: 'Classification',
        xSale: 'X-Sale',
        ratings: 'Ratings',
        area: 'Area',
        showGuestFeedback: 'Show guest feedback option on bad reviews',
      },
    },
    assortments: {
      name: 'Assortment |||| Assortments',
      fields: {
        published: 'Published',
        name: 'Name',
        code: 'Code',
        title: 'Title',
        subtitle: 'Subtitle',
        email: 'Email',
        mobileNumber: 'Mobile number',
        visitationAddress: 'Visitation address',
        'visitationAddress.addressLine1': 'Address',
        'visitationAddress.city': 'City',
        'visitationAddress.zipCode': 'Zip code',
        'visitationAddress.country': 'Country',
        loc: 'Location',
        'loc.coordinates': 'Location',
        'loc.coordinates[0]': 'Longitude',
        'loc.coordinates[1]': 'Latitude',
        'urls.jobApplication': 'Job Application URL',
        extOrderData: 'External Order data',
        'extData.externalId': 'Sync choices',
        'extOrderData.externalId': 'WSAB ID',
        appIdWhitelist: 'Published',
        countryCode: 'Country code',
        languageCode: 'Language code',
        tipLimitFactor: 'Tip limit percentage',
        tipLimit: 'Tip limit',
        quickPayFactor: 'Quick pay percentage (0 hides the button in the app)',
        billingAllowed: 'Billing allowed',
        deliveryEnabled: 'Delivery enabled',
        pickupEnabled: 'Pickup enabled',
        supportedPSPs: 'Supported payment methods',
        orderStates: 'Order status',
        paynovaLocationId: 'Paynova location ID',
        paynovaMaxAmount: 'Paynova max amount',
        tableBooking: 'Tablebooking',
        'tableBooking.href': 'Tablebooking-link',
        isOpen: 'Is open',
        'reordering.message': 'Reordering reminder',
        'reordering.timeout': 'Schedule reminder (seconds)',
        products: 'Products',
        market: 'Market',
      },
    },
    'product-activation': {
      name: 'Active product |||| Active products',
    },
    'tiered-products': {
      name: 'Tiered products',
    },
    tieredProducts: {
      t1: 'Good',
      t2: 'Better',
      t3: 'Best',
      red: 'Red Wine',
      white: 'White Wine',
      rose: 'Rose Wine',
      sparkling: 'Sparkling Wine',
    },
    phrases: {
      name: 'Phrase |||| Phrases',
      fields: {
        identifier: 'Identifier',
        translations: 'Translations',
        notes: 'Notes (context)',
      },
    },
    markets: {
      name: 'Market |||| Markets',
      fields: {
        title: 'Title',
      },
    },
    stations: {
      name: 'Station |||| Stations',
      fields: {
        title: 'Title',
        name: 'Unique name',
      },
    },
    psps: {
      name: 'PSP |||| PSPs',
      fields: {
        name: 'Name',
        active: 'Active',
        account: 'Account',
      },
    },
    users: {
      name: 'User |||| Users',
      fields: {
        username: 'User name',
        mobileNumber: 'Mobile number',
        email: 'Email',
        avatar: 'Profile foto',
        role: 'Role',
        position: 'Position',
        venues: 'Venues',
        market: 'Primary market',
        languages: 'Translation languages',
        area: 'Select a region only if the user is an Area Manager',
      },
    },
    positions: {
      name: 'Position |||| Positions',
      fields: {
        identifier: 'Identifier',
        name: 'Name',
      },
    },
    'booking-users': {
      name: 'Booking User |||| Booking Users',
      fields: {
        username: 'Username',
        password: 'Password',
        placeId: 'Places',
      },
    },
    roles: {
      name: 'Role |||| Roles',
      fields: {
        resources: 'Resources',
        subRoles: 'Sub Roles',
        superUser: 'Super User',
        translator: 'Translator',
        priceEditor: 'Price Editor',
        priceManager: 'Price Manager',
      },
    },
    academy: {
      name: 'Academy |||| Academy',
    },
    students: {
      name: 'Students |||| Students',
    },
    news: {
      name: 'News |||| News',
      fields: {
        areas: 'Areas',
        markets: 'Markets',
        positions: 'Positions',
        enableNotification: 'Send SMS notification about the news item. This will be sent to all users in the catalog. If you choose a position above it will be sent to all users with that position.',
      },
      amountOfUsersNotification: 'You will send an SMS to: ',
      users: 'users',
      smsCost: 'It will cost: ',
      notificationMessage: 'Type your SMS here',
      smsSuccess: 'It worked!',
      smsError: 'Something went wrong.',
      sendSMS: 'Send SMS',
      openSMSDialog: 'Open SMS manager',
      noEmptyBody: 'Your SMS cannot be empty.',
      alreadyNotified: 'This article has been delivered before',
      selectPositionNotification: 'If you select a position it will be sent to all users with that position.',
      smsDelay: 'It can take up to 12 minutes before the SMS messages are sent.',
    },
    courseCategory: {
      name: 'Category |||| Categories',
    },
    books: {
      name: 'E-learning |||| E-learning',
    },
    courses: {
      fields: {
        evaluationForm: 'Link to Google Form',
      },
    },
    alias: {
      name: 'Alias |||| Alias',
      type: 'Type',
      enterType: 'Enter Type',
      alias: 'Alias',
      similar: 'Similar',
      enterAlias: 'Enter Alias',
      chooseProduct: 'Select Product',
      errorText: 'Only one entry at a time. Cannot be "food" or "drink".',
      add: 'Add',
    },
    egghunt: {
      name: 'Egg Hunt',
    },
    accountingPlans: {
      fields: {
        categories: 'Categories',
        psps: 'Payment Providers',
      },
    },
    accounts: {
      fields: {
        name: 'Name',
        market: 'Market',
        defaultId: 'Default ID',
        type: 'Type',
        text: 'Text',
      },
    },
    'accounting-plans': {
      headers: {
        incoming: 'Incoming',
        outgoing: 'Outgoing',
      },
      fields: {
        'acc-name': 'Account name',
        'acc-type': 'Account type',
        'acc-number': 'Account number',
      },
    },
  },
  markets: {
    countryCode: 'Country code',
    vat: 'Vat percentage (0-100)',
    suggestedPrice: 'Suggested price',
    discountable: 'Product discountable?',
    overrideMainImageUrl: 'Replace product image for this market',
    consumesLoyalty: 'Uses loyalty points',
    producesLoyalty: 'Gives loyalty points',
    ignorePriceSegment: 'Custom price range',
  },
  'edit.title': 'Edit "%{title}"',
  validate: 'Validate',
  unpublish: 'Save and Unpublish',
  publish: 'Save and Publish',
  unpublishConfirm: 'Are you sure you want to unpublish',
  activateSync: 'Activate sync',
  food: 'Food',
  drink: 'Drink',
  paynova: 'Paynova',
  paynovainvoice: 'Paynova invoice',
  paynova3ds: 'Paynova 3D Secure',
  cash: 'Cash',
  free: 'Free',
  vipps: 'Vipps',
  swish: 'Swish',
  selectAll: 'Select all',
  deselectAll: 'Deselect all',
  hideLocked: 'Hide standard products',
  showLocked: 'Show standard products',
  info: 'Info',
  payment: 'Payment',
  productManagement: 'Product management',
  clone: 'Clone',
  close: 'Close',
  lockedPrice: 'Locked price',
  start: 'Start',
  end: 'End',
  'data.start': 'Start',
  'data.end': 'End',
  selectMarket: 'Choose market',
  thisCantBeChanged: "This can't be changed later",
  promoteToMainImage: 'Promote to product image',
  recipeCreated: 'Recipe created!',
  recipeAdded: 'Recipe added!',
  recipeIngredientsUpdated: 'Recipe ingredients updated!',
  recipe: 'Recipe',
  recipeName: 'Recipe name',
  newRecipe: 'New Recipe',
  existingRecipe: 'Existing Recipe',
  add: 'Add',
  cancel: 'Cancel',
  submit: 'Submit',
  edit: 'Edit',
  remove: 'Remove',
  login: 'Login',
  contact: 'Contact',
  subscriptions: 'Subscriptions',
  emailSubscriptions: 'Email subscriptions',
  missingTranslations: 'Missing translation |||| Missing translations',
  codeHint: 'Leave blank for autogenerated code',
  internalNameHint:
    'Unique identifier used internally to identify the product, always in english, a good example is "Cheeseburger Bacon Heden"',
  filledAfterSave: 'These fields are available after initial save of this product!',
  publishMessages: {
    noTitleProvided: 'No title provided',
    noSubTitleProvided: 'No subtitle provided',
    noCodeProvided: 'No code provided',
    noCoordinatesProvided: 'Coordinates missing',
    noProductsChosen: 'No products chosen',
    noAddressProvided: 'No address provided',
    noCityProvided: 'No city provided',
    noZipCodeProvided: 'No zip code provided',
    noCountryProvided: 'No country provided',
    invalidUrl: 'URL is not valid',
    noPaymentMethods: 'No payment methods active',
    syncDisabled: 'Sync disabled',
    invalidTableBookingLink: 'Invalid bookinglink',
    noStations: 'No stations selected',
    noValidMarkets: 'No valid market',
    invalidMarkets: 'One or more invalid markets',
    noImage: 'No image',
    noAllergens: 'No allergens (old) chosen',
  },
  academy: {
    academy: 'Academy',
    pinchoversity: 'Pinchoversity',
    bookTitle: 'boktitel',
    book: 'Book',
    books: 'Books',
    chapter: 'Chapter',
    chapters: 'Chapters',
    page: 'Page',
    pages: 'Pages',
    question: 'Question',
    questions: 'Questions',
    genre: 'Genre',
    studentFetchError: 'We could not find your student information! Try again later!',
    booksFetchError: 'We could not find your books! Try again later!',
    quizValidationError: 'Could not check your answers right now. Try again later!',
    course: 'Course',
    courses: 'Courses',
    'course.readMore': 'Take Course',
    'book.readMore': 'Read',
    courseMoment: 'Course Moment',
    courseMoments: 'Course Moments',
    teacher: 'Teacher',
    attendees: 'Attendees',
    maxAttendees: 'Max Attendees',
    address: 'Address',
    city: 'City',
    lastRegistrationDate: 'Last Registration date',
    courseRegistration: 'Course Registration',
    registrationFullMessage: 'There are not enough spots.',
    registrationEmptyMessage: 'Select someone in the list to register them.',
    alreadyRegisteredMessage: 'is already registered.',
    'alreadyRegisteredMessage.pl': 'are already registered.',
    startDate: 'Start Date',
    endDate: 'End Date',
    openSpots: 'Open Spots',
    register: 'Register',
    description: 'Description',
    newsPublishSuccess: 'Your news item has been published!',
    newsPublishFailure: 'Could not publish your news item.',
    registeredCourses: 'Registered Courses',
    completedCourses: 'Course Certificates',
    registerComments: 'Comments, e.g., allergies, diets, requests, etc.',
    invite: 'Invite',
    introBlurb:
      'This is our collection of educational material - both e-learning available in your mobile phone and courses held by instructors that are available for registration. Click below to see what you can learn more about.',
    elearningBlurb:
      'Hej här hittar du våra e-learning böcker. Varje kurs innehåller dels text, dels videos, varje kapitel avslutas med lite kontrollfrågor. När du klarat alla kontrollfrågor har du klarat kursen. Du kan hitta vilka kurser du klarat under din profil. Lycka till. All feedback är välkommen och skickas till linda.holm@pinchos.se',
    coursesBlurb:
      'Hej här hittar du de lärarledda kurser vi erbjuder. Under varje kurs hittar du planerade kurstillfällen och vart kursen äger rum. Restaurangchefen är den som anmäler vilka det är som ska deltaga.',
    elearningSpan: 'coming soon',
    coursesSpan: 'browse courses and register',
    startTime: 'Start Time',
    endTime: 'End Time',
    takeCourse: 'Take Course',
    moreInfo: 'More information',
    elearning: 'E-learning',
    continue: 'Continue',
    teacherLedCourses: 'Instructed Courses',
    registerSuccessBlurb:
      'Thank you for registering, you and your staff can find it in your profile.',
    noRegisteredCourses: 'You are not registered for any courses!',
    coursesLink: 'Click here to find courses!',
    continueTo: 'Continue to',
    correctMessage: 'Message if you answer correctly',
    incorrectMessage: 'Message if you answer incorrectly',
    courseCategory: 'Category',
    pageTitle: 'Page Title',
    chapterEnd: 'End of Chapter',
    courseDoneBlurb: 'You finished the course!',
    congratulations: 'Congratulations!',
    noCourseMomentsBlurb: 'There are no planned course moments at this time.',
    welcome: 'Welcome to ',
    completedElearning: 'Completed Elearningkurser',
    chapterCompleted: 'Chapter Complete! Click the button below to continue!',
    theEnd: 'The End',
    quizFetchError: 'Could not save your results.',
    blankFields: 'Please fill in all fields',
    courseOverview: 'Course Overview',
    confirmDeleteCourseMoment: 'Are you sure you want to delete course moment: ',
    deleteAttendeeParty: 'Remove Group',
    confirmDeleteParty: 'Are you sure you want to delete the group: ',
    removeCourseMoment: 'Remove Course Moment',
    venue: 'Venue',
    noDefaultVenueMessage: 'You need to have a default venue to register employees to courses',
    unRegister: 'Remove Registration',
    coursesSuccessMessage: 'Congratulations! You completed the course!',
  },
  menuTitles: {
    products: 'Product Management',
    users: 'User Management',
    academy: 'Pinchoversity Management',
    vip: 'VIP Content',
    accounting: 'Accounting',
  },
  website: {
    header: 'Header',
    header1: 'Heading 1',
    header2: 'Heading 2',
    header3: 'Heading 3',
    header4: 'Heading 4',
    size: 'Size',
    show: 'Show',
    androidLink: 'Android Link',
    giftcardTemplateId: 'Giftcard template ID',
    iosLink: 'iPhone Link',
    imageWide: 'Wide Image',
    imageSquare: 'Square Image',
    appPromotion: 'App Promotion',
    headingText: 'Heading text',
    bodyText: 'Text',
    imageUrl: 'Image link',
    standardLayout: 'Standard layout',
    textAlign: 'Text alignment',
    buttonText: 'Button text',
    link: 'Link',
    alt: 'Alt text (text that will show e.g. if the image cannot be loaded)',
    internal: 'Internal link (navigation)',
    blockHeading: 'Block heading',
    blockCopy: 'Block text',
    blockImage: 'Block image',
    blockButton: 'Block button (leave empty for no button)',
    blocks: {
      name: 'Block',
      imageAndText: 'Image with text',
      heading: 'Heading',
      button: 'Button',
      faq: 'FAQ',
      image: 'Image',
      text: 'Text',
      youtube: 'YouTube video',
      contactForm: 'Contact form',
    },
  },
  news: {
    news: 'News',
    'news.sg': 'News Item',
    post: 'Post',
    north: 'North-east',
    south: 'South-west',
    central: 'PN',
    'load-older': 'Load older news',
  },
  statistics: {
    title: 'Statistics',
    selectMarket: 'Select Market',
    selectArea: 'Select Area',
    north: 'North-east',
    south: 'South-west',
    central: 'PN',
    products: 'Products',
    allProducts: 'All Products',
    categories: 'Categories',
    defaultProducts: 'Default Products',
    venues: 'Venues',
    allVenues: 'All Venues',
    area: 'Area',
    cluster: 'Cluster',
    fetchingData: 'Fetching data...',
    downloadCSV: 'Download as CSV',
    query: 'Query',
    selected: 'selected',
    selectCategory: 'Select Category',
    coastal: 'Coastal City',
    city: 'City',
    period: 'Period',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    yearly: 'Yearly',
    minutewise: 'Minutewise',
    hourly: 'Hourly',
    selectCluster: 'Select Cluster',
    date: 'Date',
    interval: 'Interval',
    from: 'From',
    to: 'To',
    SE: 'Sweden',
    DK: 'Denmark',
    NO: 'Norway',
    FI: 'Finland',
    DE: 'Germany',
    UK: 'United Kingdom',
    guests: 'Guests',
    allBookingsTypes: 'All types',
    booked: 'Booked',
    cancelled: 'Cancelled',
    noShow: 'No-shows',
    denied: 'Denied',
    dropIns: 'Drop ins',
    seatingDate: 'Seating Date',
    bookingDate: 'Booking Date',
    bookingType: 'Type of Booking',
    dateType: 'Type of Date',
    'ort>50k': 'Ort > 50k',
    'ort<50k': 'Ort < 50k',
    sales: 'Sales',
    guestsAmount: 'Amount of Guests',
    sameStoreSales: 'Same Store Sales',
    drinks: 'Drinks',
    food: 'Food',
  },
  translations: {
    translatable: 'Translatable',
    referenceLanguage: 'Reference Language',
    SE: 'Sweden',
    DK: 'Denmark',
    NO: 'Norway',
    FI: 'Finland',
    DE: 'Germany',
    UK: 'United Kingdom',
  },
  diploma: {
    download: 'Download Diploma',
  },
  languages: {
    sv: 'Swedish',
    en: 'English',
    nb: 'Norwegian',
    da: 'Danish',
    fi: 'Finnish',
    de: 'German',
    es: 'Spanish',
  },
  errors: {
    'save-failed': 'Save failed, reason: ',
    'fetch-failed': 'Loading failed, reason: ',
  },
  'save-success': 'Saved!',
  show: 'Show',
  reason: 'Reason',
  feedback: 'Feedback',
  searchNewValue: 'Search for a new value',
  currentValue: 'Currently selected value',
  searchAndSetOverride: "Search for new value to override Markets' value",
  currentMarketValue: "Markets' value",
  reset: 'Reset',
  price: 'Price',
  noPriceSetMsg: 'No price set',
  onlyDeactivateMsg: 'Missing market price, can only be deactivated',
  missingMin: "Price can't be set because of missing Min. price",
  missingMax: "Price can't be set because of missing Max. price",
  missingMinAndMax: "Price can't be set because of missing Min. and Max. price",
  valueNotInRange: 'Value is not in range',
  save: 'Save',
  undefined: 'undefined',
  search: 'Search %{queryables}',
  name: 'name',
  email: 'Email',
  categories: 'categories',
  permissions: 'Permissions',
  organisation: 'Organisation',
  restaurantManager: 'Restaurant manager',
  steward: 'Host',
  waiter: 'Waiter',
  barManager: 'Bar manager',
  bartender: 'Bartender',
  chef: 'Chef',
  sousChef: 'Sous chef',
  cook: 'Cook',
  dishwasher: 'Dishwasher',
  prospect: 'Prospect',
  areaManager: 'Area manager',
  franchisees: 'Franchisee',
  socialMediaManager: 'Social media manager',
  economy: 'Economy',
  userFoundWithNumber: 'Found user with phone number %{phoneNumber}!',
  userHasPosition: 'User already has this position!',
  userNotFoundFillForm: 'No user found, fill form below',
  from: 'from',
  for: 'for',
  phoneNumber: 'Phone number',
  fullName: 'Full name',
  referenceNumber: 'Reference number',
  referenceNumberRequired: 'Reference number is required',
  nameIsRequired: 'Name is required',
  emailIsRequired: 'Email is required',
  query: 'Search',
  places: 'Restaurants',
  'create.item': 'Create %{item}',
  readMore: 'Read more',
  allLanguages: 'All Languages',
  'edit.item': 'Edit %{item}',
  home: 'Home',
  title: 'Title',
  textBody: 'Text Body',
  language: 'Language',
  option: 'Option',
  correct: 'Correct',
  incorrect: 'Incorrect',
  icon: 'Icon',
  back: 'Back',
  previous: 'Previous',
  next: 'Next',
  'previous.item': 'Previous %{item}',
  'next.item': 'Next %{item}',
  globalSettings: 'Pinchos global settings',
  globalPspCaption: 'PSP kill switch',
  tag: 'Tag',
  tags: 'Tags',
  answer: 'Answer',
  position: 'Position',
  positionsHintText: 'Choose who can see the content. Leave it empty to let everyone see it.',
  swedish: 'Swedish',
  english: 'English',
  helpdesk: 'System Status',
  marketingPortal: 'Marketing Portal',
  booking: 'Booking',
  jobs: 'Job Openings',
  'choose.item': 'Choose %{item}',
  file: 'File',
  'hide.item': 'Hide %{item}',
  'show.item': 'Show %{item}',
  comments: 'Comments',
  import: 'Import',
  export: 'Export',
  updated: 'Updated',
  perPage: 'Per Page',
  all: 'All',
  created: 'Created',
  and: 'and',
  edited: 'edited',
  others: 'Others',
  date: 'Date',
  goToProfile: 'To Profile',
  externalLinks: 'External links',
  Price: 'Price',
  subtitle: 'Subtitle',
  games: 'Sales event',
  'booking-settings': 'Booking settings',
  unauthorizedHeader: 'You are unauthorized to view this page!',
  unauthorizedText: 'Contact your Restaurant Manager or Area Manager for more information.',
  print: 'Print',
  venues: 'Venues',
  activeVenues: 'Active Venues',
  market: 'Market',
  venue: 'Restaurang',
  articleGroups: 'Article groups',
  missingContents: 'Missing contents',
  reimbursement: 'Refund',
  'marketing-material': 'Marketing materials',
  'catalog-title': 'Pincho Nation Catalog',
  bireports: 'BI Report',
  open: 'Open',
  openingHour: 'Opening time',
  closingHour: 'Closing time',
  timezone: 'Timezone',
  openHours: 'Open hours',
  late: 'Late',
  'provisional-products.preliminary-form': 'Fill out this form before anything else:',
  'pn-contact': 'PN Contact',
  'assortment-moved-title': 'Assortment has been moved',
  'assortment-moved-text': 'All activation and pausing is now done via Restaurant Assortment. This change means no more delay between pausing and activating, plus guests who try to order a paused product will get a notification telling them exactly which product is no longer available.',
  'organisation-moved-title': 'Organisation tree has been moved',
  'organisation-moved-text': 'The organisation tree is now in Restaurant.',
  'news-moved-title': 'News has been moved',
  'news-moved-text': 'All news is now in Workplace.',
};
